// Marubazu — Site Copy & Config
// Edit this ONE file to change any text on the site.
// Anything in [brackets] is a placeholder you still need to replace.

export const SITE = {
  name: "Marubazu",
  // WhatsApp number with country code, digits only. Used for all chat links.
  whatsappNumber: "919002491890",
  email: "", // hidden on site
  phone: "+91 90024 91890",
  address: "", // hidden on site
};

export const HERO = {
  tag: "For traders who are tired of losing money",
  titleA: "Stop Losing Money to Random Trades.",
  titleHighlight: "Trade With Experts Beside You.",
  sub: "In [90 days], build your own written trading plan and get 30 of your trades reviewed by real market experts. Join Marubazu's live trading workspace, online or offline.",
  ticks: [
    "No tips. No signals. No guessing.",
    "Live market analysis every trading day",
    "Not happy after [14 days]? Get a [full refund].",
  ],
  cta: "Inquire Now",
  smallText: "A 15-minute call. We look at how you trade today and tell you honestly if Marubazu is right for you. Only [X] seats in each batch.",
  trust: "[500+] traders trained · [4.9/5] rating · Live every market day",
  liveTag: "LIVE SESSION",
};

export const MARQUEE_WORDS = ["NOT TIPS", "FACE TO FACE", "LIVE MARKET", "REAL EXPERTS", "DISCIPLINE", "NO GAMBLING"];

export const PROBLEM = {
  eyebrow: "Why Traders Keep Losing",
  title: "THIS PAGE IS FOR YOU IF...",
  items: [
    "You trade, and your account keeps going down.",
    "You buy on fear and sell on panic.",
    "You enter a trade, then have no idea when to exit.",
    "You lose money, then trade bigger to win it back.",
    "You learn from YouTube, Instagram and Telegram, and now you are more confused than before.",
    'You followed a tip or a "guru" and paid for it.',
    "You trade alone. Nobody checks your trades or tells you what went wrong.",
    "You feel angry, low or stressed after every red day.",
    "You want trading to become a second income, but you don't know where to start.",
    "Deep down, it feels more like gambling than a skill.",
  ],
  closing: 'If you said "yes" to even one, the problem is not you. You just never had a system, a mentor, or a room full of serious traders.',
};

export const TURNING_POINT = {
  eyebrow: "The Marubazu Way",
  titleA: "Good Traders Are Not Born Lucky.",
  titleHighlight: "They Are Built With a System.",
  text: "Most people lose in the market for 3 simple reasons. 1) They have no clear rules. 2) They have no one to check their work. 3) They trade alone, with fear and greed in charge. Marubazu fixes all three. You get a step-by-step roadmap, experts who review your trades, and a live trading workspace full of serious traders. The market stops feeling like gambling. It starts feeling like a business, with a plan, rules and a daily routine.",
  bigLine: "We don't sell tips. We build traders.",
};

export const WHAT_YOU_GET = {
  eyebrow: "What You Get",
  title: "EVERYTHING YOU NEED TO TRADE WITH CONFIDENCE",
  items: [
    { icon: "Map", title: "Step-by-step Roadmap", text: "Learn from zero to a full trading plan, in the right order. No more random videos." },
    { icon: "Users", title: "Expert Mentorship", text: "Talk to experienced traders and ask anything." },
    { icon: "ClipboardCheck", title: "Trade Reviews", text: "Share your trades. Experts show you what went right, what went wrong, and how to fix it." },
    { icon: "Activity", title: "Live Market Analysis", text: "Watch experts read the market live, and learn why they take or skip a trade." },
    { icon: "Monitor", title: "Trading Workspace", text: "Trade next to serious traders, offline at our centre or online from home." },
    { icon: "Shield", title: "Risk and Mindset Training", text: "Learn how much to risk, when to exit, and how to stay calm when the market moves." },
    { icon: "MessageCircle", title: "Serious Trader Community", text: "A group of disciplined traders to learn with, not a Telegram group full of tips." },
  ],
  bonus: "[Class recordings] · [Trading journal template] · [Weekly market review]",
};

export const HOW_IT_WORKS = {
  eyebrow: "How It Works",
  title: "FROM CONFUSED TO CONFIDENT IN 4 SIMPLE STEPS",
  steps: [
    { title: "Book your free check-up.", text: "A 15-minute call. We learn how you trade today and what is going wrong." },
    { title: "Get your roadmap.", text: "We place you in the right batch and give you a clear plan, from basics to a full trading system." },
    { title: "Learn and trade live with experts.", text: "Join the live market sessions in the workspace, offline or online. Ask questions as the market moves." },
    { title: "Get your trades reviewed.", text: "Share your trades. Experts fix your mistakes, so you stop repeating them." },
  ],
  cta: "Inquire Now",
};

export const BEFORE_AFTER = {
  eyebrow: "The Shift",
  title: "BEFORE AND AFTER MARUBAZU",
  beforeLabel: "Before",
  afterLabel: "After",
  rows: [
    ["Confused about what to learn", "A clear step-by-step roadmap"],
    ["Random trades, no rules", "A written plan with entry, exit and risk rules"],
    ["Trading on fear, greed and FOMO", "Calm, planned decisions"],
    ["Chasing tips and signals", "Trading your own system"],
    ["Trading alone", "Trading beside experts and serious traders"],
    ["Nobody checks your trades", "Every trade can be reviewed and improved"],
    ["Revenge trading after a loss", "A recovery plan that protects your capital"],
    ["Trading feels like gambling", "Trading feels like a business"],
  ],
};

export const WHO_FOR = {
  eyebrow: "Is This You?",
  titleA: "BE HONEST WITH YOURSELF.",
  titleHighlight: "IS THIS RIGHT FOR YOU?",
  forYou: {
    title: "Marubazu is for you if:",
    items: [
      "You are a beginner who wants to learn trading the right way.",
      "You already trade, but keep losing money.",
      "You want trading as a part-time or full-time income, and are ready to work for it.",
      "You want to learn from experts, not from random tips.",
      "You are ready to follow rules and stay disciplined.",
    ],
  },
  notForYou: {
    title: "Marubazu is NOT for you if:",
    items: [
      'You want tips, signals or "sure shot" calls.',
      "You want to get rich quick.",
      "You don't want to follow risk rules.",
      "You are looking for someone to trade your money for you.",
    ],
  },
};

export const PROOF = {
  eyebrow: "Proof",
  titleA: "REAL TRADERS.",
  titleHighlight: "REAL CHANGE.",
  note: "Placeholders below — swap in your real student videos, mentors and workspace photos.",
  testimonials: [
    { name: "[Student Name]", city: "[City]", line: "[One line on what changed for them]", image: null },
    { name: "[Student Name]", city: "[City]", line: "[One line on what changed for them]", image: null },
    { name: "[Student Name]", city: "[City]", line: "[One line on what changed for them]", image: null },
    { name: "[Student Name]", city: "[City]", line: "[One line on what changed for them]", image: null },
  ],
  mentors: [
    { name: "[Mentor Name]", years: "[X]+ years", trades: "[What they trade]", image: "https://images.unsplash.com/photo-1659353220482-554773c2f7fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NzV8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBwcm9mZXNzaW9uYWwlMjBtYW4lMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwc3VpdHxlbnwwfHx8fDE3OTMzODA4NzV8MA&ixlib=rb-4.1.0&q=85" },
    { name: "[Mentor Name]", years: "[X]+ years", trades: "[What they trade]", image: "https://images.unsplash.com/photo-1637589274742-8d4c152720a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NzV8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBwcm9mZXNzaW9uYWwlMjBtYW4lMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwc3VpdHxlbnwwfHx8fDE3OTMzODA4NzV8MA&ixlib=rb-4.1.0&q=85" },
    { name: "[Mentor Name]", years: "[X]+ years", trades: "[What they trade]", image: "https://images.unsplash.com/photo-1589386417686-0d34b5903d23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NzV8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBwcm9mZXNzaW9uYWwlMjBtYW4lMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwc3VpdHxlbnwwfHx8fDE3OTMzODA4NzV8MA&ixlib=rb-4.1.0&q=85" },
  ],
  gallery: [
    { caption: "Chart patterns class with the batch", image: "https://customer-assets-agu9un31.emergentagent.net/job_marubazu-desk--7tlqvpf5/artifacts/15fce348e5f05632_image.png" },
    { caption: "Inside Marubazu Trading Hub — our offline workspace", image: "https://customer-assets-agu9un31.emergentagent.net/job_marubazu-desk--7tlqvpf5/artifacts/5106e61715e55b49_image.png" },
    { caption: "Live session — mentor reading the chart on the big screen", image: "https://customer-assets-agu9un31.emergentagent.net/job_marubazu-desk--7tlqvpf5/artifacts/860f2254581bb5b1_image.png" },
  ],
};

export const OFFER = {
  eyebrow: "Zero Risk",
  titleA: "TRY MARUBAZU FOR [14 DAYS].",
  titleHighlight: "ZERO RISK.",
  text: "Join the workspace, attend the live sessions, and get your first trade reviewed. If you don't feel clearer, calmer and more in control within [14 days], tell us and we will give you a [full refund]. No questions asked.",
  checklist: [
    "Step-by-step trading roadmap",
    "Live market analysis sessions",
    "Expert mentorship",
    "30 trade reviews in [90 days]",
    "Access to the trading workspace (offline and online)",
    "Serious trader community",
    "[Bonuses]",
  ],
  priceBox: ["[Price]", "[Payment options]", "Only [X] seats this batch"],
  cta: "Inquire Now",
  whatsappLine: "Not sure yet? Chat with us on WhatsApp.",
};

export const FAQ = {
  eyebrow: "Questions",
  title: "EVERYTHING YOU WANT TO ASK",
  items: [
    { q: "Do I need any trading knowledge?", a: "No. We start from the basics and take you step by step." },
    { q: "I have already lost money. Is this for me?", a: "Yes. This is built for traders who keep losing and want to fix how they trade, with rules and risk control." },
    { q: "Do you give tips or signals?", a: "No. We teach you how to read the market and make your own decisions. We are not a tip provider." },
    { q: "Can I join online?", a: "Yes. You can join online or offline at our workspace. [Confirm location and timings.]" },
    { q: "How much time do I need every day?", a: "[Class time] plus [practice time]. You can fit it around a job." },
    { q: "Will I make money?", a: "No one can promise that, and we don't. Trading has risk. We help you trade with a plan, rules and expert feedback, so your decisions are better." },
    { q: "What if it is not for me?", a: "Tell us within [14 days] and you get a [full refund]." },
    { q: "How much does it cost?", a: "[Price]. Book a free check-up and we will tell you which plan fits you." },
  ],
};

export const FINAL_CTA = {
  titleA: "YOU CAN KEEP TRADING ALONE,",
  titleHighlight: "OR YOU CAN BUILD A SYSTEM.",
  text: "Every red day teaches you nothing if nobody shows you what went wrong. At Marubazu, experts sit beside you, review your trades and help you build a plan you can trust. Book a free 15-minute check-up. We will look at how you trade today and tell you honestly if we can help.",
  primary: "Inquire Now",
  secondary: "Chat on WhatsApp",
};

export const FOOTER = {
  disclaimer: "Marubazu provides stock market and trading education. We are not a SEBI-registered investment advisor. We do not give stock tips, buy or sell recommendations, or guarantee any returns. Trading in the stock market involves risk of loss. Past performance or examples shown are for learning only.",
  copyright: "© 2026 Marubazu. All rights reserved.",
  links: [
    { label: "Why Us", href: "#why-us" },
    { label: "What You Get", href: "#what-you-get" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
  ],
};

export const NAV_LINKS = [
  { label: "Why Us", href: "#why-us" },
  { label: "What You Get", href: "#what-you-get" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "FAQ", href: "#faq" },
];

// ---- Multi-step "Inquire Now" form ----
// Steps 1-5 are questions; step 6 is the contact screen.
export const INQUIRY = {
  eyebrow: "CHECK-UP",
  totalSteps: 6,
  steps: [
    {
      id: "experience",
      type: "single",
      question: "Where are you in your trading journey right now?",
      helper: "This helps us place you in the right batch.",
      options: [
        "I'm a complete beginner",
        "I trade, but I keep losing money",
        "I trade part-time and want to improve",
        "I trade full-time and want to level up",
      ],
    },
    {
      id: "problems",
      type: "multi",
      max: 2,
      question: "What is your biggest trading problem today?",
      helper: "Pick up to 2. Be honest, it helps us help you.",
      options: [
        "I can't recover my losses",
        "I don't know when to enter or exit",
        "Fear and greed make my decisions",
        "I trade alone, nobody checks my trades",
        "I follow tips and they don't work",
        "I don't know where to start",
      ],
    },
    {
      id: "markets",
      type: "multi",
      question: "Which markets do you want to trade?",
      helper: "Choose all that apply. Our workspace covers them.",
      options: [
        "Stocks (NSE / BSE)",
        "Options (F&O)",
        "Commodities",
        "Forex",
        "Crypto",
        "Not sure yet",
      ],
    },
    {
      id: "join",
      type: "dual",
      question: "How would you like to join, and when?",
      helper: "We run live sessions online and in our workspace.",
      parts: [
        { id: "mode", label: "Mode", options: ["Online", "Offline at the workspace", "Not sure yet"] },
        { id: "timing", label: "Timing", options: ["Weekday mornings", "Weekday evenings", "Weekends", "Flexible"] },
      ],
    },
    {
      id: "capital",
      type: "single",
      optional: true,
      question: "How much capital do you plan to trade with?",
      helper: "This helps your mentor plan position size and risk for you. Optional.",
      options: [
        "Below ₹50,000",
        "₹50,000 to ₹1 lakh",
        "₹1 lakh to ₹2 lakh",
        "Above ₹2 lakh",
        "I'd rather not say",
      ],
    },
  ],
  contact: {
    question: "Where should we call you?",
    helper: "A Marubazu mentor will call you for your free 15-minute Trading Check-up. No spam. We will not share your number.",
    consentLabel: "I agree to be contacted on call or WhatsApp about my check-up.",
    submit: "Book My Free Check-up",
  },
  thankYou: {
    title: "You're In, {firstName}!",
    text: "A Marubazu mentor will call you within [24 hours] to plan your free 15-minute Trading Check-up.",
    whatsapp: "Chat on WhatsApp",
    smallLine: "While you wait, think about your last losing trade. We'll look at it together.",
  },
};

export const IMAGES = {
  // Placeholder video poster for the hero phone mockup (swap with your own video later)
  heroPoster: "https://images.unsplash.com/photo-1560221328-12fe60f83ab8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxzdG9jayUyMG1hcmtldCUyMGNoYXJ0JTIwZGFyayUyMHRleHR1cmV8ZW58MHx8fHwxNzkzMzgwODcwfDA&ixlib=rb-4.1.0&q=85",
  // Your brand reel, playing inside the phone mockup. Set to "" to fall back to the placeholder poster.
  heroVideo: "https://customer-assets-agu9un31.emergentagent.net/job_marubazu-desk--7tlqvpf5/artifacts/d1c217b3a6811f4f_Marubazu_Brand_Reel_v2.mp4",
};

// ---- CRM config: labels, stages, dropdown options (edit freely) ----
export const TRACKING = {
  metaPixelId: "[Pixel ID]", // <-- replace with your Meta Pixel ID to fire the "Lead" event on the thank-you page
};

export const CRM = {
  statuses: [
    { id: "hot", label: "Hot" },
    { id: "warm", label: "Warm" },
    { id: "cold", label: "Cold" },
  ],
  // tone: positive = green, progress = yellow, lost = red/grey, neutral = grey
  stages: [
    { id: "New Lead", tone: "progress" },
    { id: "DNP (Did Not Pick)", tone: "progress" },
    { id: "Call Done", tone: "progress" },
    { id: "Follow Up", tone: "progress" },
    { id: "Check-up Booked", tone: "progress" },
    { id: "Check-up Done", tone: "progress" },
    { id: "Ready to Buy", tone: "positive" },
    { id: "Enrolled", tone: "positive" },
    { id: "In 14-Day Trial", tone: "positive" },
    { id: "Full Program Enrolled", tone: "positive" },
    { id: "Ghosted", tone: "lost" },
    { id: "Not Interested", tone: "lost" },
    { id: "Can't Afford", tone: "lost" },
    { id: "Refund Requested", tone: "lost" },
    { id: "Other", tone: "neutral" },
  ],
  callOutcomes: ["Picked", "Not picked", "Busy", "Call back later"],
  followupWhatsApp: "Hi {name}, this is Marubazu. Thanks for booking your free Trading Check-up. When is a good time for your 15-minute call with our mentor?",
  batchSection: {
    eyebrow: "Next Batch",
    seatsLabel: "seats left",
  },
};
